import React from 'react';
import { motion } from 'framer-motion';

interface CoolnessIndicatorProps {
  coolnessFactor: number;
}

export const CoolnessIndicator: React.FC<CoolnessIndicatorProps> = ({ coolnessFactor }) => {
  return (
    <div className="mt-6">
      <h3 className="text-lg font-bold mb-2 text-primary">Coolness Factor</h3>
      <div className="bg-gray-200 rounded-full h-4 overflow-hidden">
        <motion.div
          className="h-full bg-gradient-to-r from-blue-500 to-purple-500"
          initial={{ width: 0 }}
          animate={{ width: `${coolnessFactor}%` }}
          transition={{ duration: 0.5 }}
        />
      </div>
      <div className="text-right text-sm text-white mt-1">{coolnessFactor.toFixed(0)}% Cool</div>
    </div>
  );
};